module.exports = __webpack_public_path__ + "img/positive_result.d96526bd.png";